// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__3kVKd","hasMarks":"Slider_hasMarks__srtkQ"};